import type { CategoryImageKey, CategoryImagesConfig } from '@iheartjane/types';

// Defaults are bundled assets imported from the menu package. A custom image is
// either a freshly uploaded data URI or, once published, a Jane-hosted URL.
export const isCustomCategoryImage = (image?: string) =>
  !!image && (image.startsWith('data:') || image.includes('iheartjane.com'));

// New custom images are sent as [category]: value; custom images reverted
// to a default are sent as [category]: null so the API clears them.
export const categoryImagesToUpdate = (
  images: CategoryImagesConfig,
  previousImages: CategoryImagesConfig
) => {
  const updates: { [key in CategoryImageKey]?: string | null } = {};

  for (const [key, value] of Object.entries(images) as [
    CategoryImageKey,
    string,
  ][]) {
    if (isCustomCategoryImage(value)) {
      updates[key] = value;
    } else if (isCustomCategoryImage(previousImages[key])) {
      updates[key] = null;
    }
  }

  return updates;
};
